module.exports = __webpack_public_path__ + "img/anec.9818e65d.png";